import { CHEMICAL_FIELDS } from "../chemicalLibrary.constants";

import { ADD_EDIT_FORM_CONTROLS } from "./ChemicalLibraryAddEditDialog.constants";

const getEditableFields = () => {
  return [CHEMICAL_FIELDS.price, CHEMICAL_FIELDS.unit];
};

/**
 * Formats the chemical form data by populating the form controls with the provided chemical data.
 * It also sets the options for category and chemical fields based on the provided categories and chemicals.
 *
 * @param {Object} chemicalData - The data of the chemical to be formatted.
 * @param {Array} options.chemicalCategories - The list of chemical categories.
 * @param {Object} options.chemicalsByCategoryId - The chemicals grouped by category ID.
 * @returns {Object} - The formatted form controls with populated values and options.
 */
export const formatChemicalDataToFormData = (t, chemicalData) => {
  // Deep Clone the form controls to avoid mutating the original
  let formControls = structuredClone(ADD_EDIT_FORM_CONTROLS(t));

  if (chemicalData) {
    const editableFields = getEditableFields();
    formControls = Object.entries(formControls).reduce(
      (updatedControls, [fieldKey, fieldConfig]) => {
        const updatedFieldConfig = {
          ...fieldConfig,
          value: chemicalData[fieldKey],
          disabled: !editableFields.includes(fieldKey),
        };

        return { ...updatedControls, [fieldKey]: updatedFieldConfig };
      },
      {},
    );
  }

  return formControls;
};
